import * as Yup from 'yup';

export const UploadResumeFormValidationSchema = Yup.object().shape({
  Resume: Yup.mixed()
    .nullable()
    .test('fileFormat', 'This type of file is not supported', value => {
      return (
        !value || new RegExp(/\.(doc|docx|pdf|odt|rtf)$/i).test(value.name)
      );
    })
    .test('fileSize', 'The file is too big. Max file size is 2MB', value => {
      return !value || value.size <= 2 * 1024 * 1024;
    }),
});

export default UploadResumeFormValidationSchema;
